module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M30 0H2a2 2 0 0 0-2 2v28a2 2 0 0 0 2 2h28a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zM8 8H4V4h4v4zm13.702 14.878a1 1 0 0 1 0 1.414l-1.414 1.414a1 1 0 0 1-1.414 0l-2.878-2.878-2.868 2.868a1 1 0 0 1-1.414 0L10.3 24.282a1 1 0 0 1 0-1.414L13.166 20l-2.868-2.868a1 1 0 0 1 0-1.414l1.414-1.414a1 1 0 0 1 1.414 0l2.868 2.868 2.878-2.878a1 1 0 0 1 1.414 0l1.414 1.414a1 1 0 0 1 0 1.414L18.822 20l2.88 2.878zM28 8H12V4h16v4z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/close-browser-1.js
// module id = 1068
// module chunks = 14